import "./Contact.module.css";
import SiteHeader from "@/reusable_sections/Header";
import SecureEngagement from "./sections/SecureEngagement";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <SiteHeader />
      <SecureEngagement />
      <ContactUs />
      <Footer />
    </div>;
}